[
  { "pays": "France Métropolitaine", "country": "FR", "taxCode": "VE_FR" }
]